<style lang="scss" scoped>
.classes {
	&__container {
		@include container;
		justify-content: center;
	}
	&__panel {
		@include main-panel;
		display: flex;
	}
	&__header {
		@include flex-center;
		&__options {
			margin-left: auto;
		}
	}
	&__card {
		cursor: move;
		display: inline-block;
		margin: 15px;
		text-align: left;
	}
	&__footer {
		@include main-panel-footer;
		display: flex;
		justify-content: space-between;
	}
	&__grouping {
		flex: 0 0 75%;
		border-right: 1px solid #eee;
	}
	&__draggable-panel {
		height: 800px;
		overflow: auto;
		justify-content: center;
		text-align: center;
	}
	&__mis-classes {
		flex: 0 0 25%; 
		background-color: #fff;
		box-sizing: border-box;
	}
	&__toolbar {
		padding: 20px;
		border-bottom: 1px solid #eee;
	}
	&__footer-menu {
		border: 1px solid #eee;
		padding: 30px 30px 20px;
		font-size: 14px;
	}
	&__switch-label {
		color: #000;
		margin: 5px;
	}
	&__search-input{
		float: right;
		margin-top: -3px;
	}
	&__load-more-btn{
		display: flex;
    	justify-content: center;
    	margin: 20px auto;
    	width: 100%; 
	}
	&__pad-top15 {
		padding-top: 15px;
	}
}
.ghost {
	opacity: 0.2;
	border: 2px dashed#000;
}
.right {
	float: right;
}
.scroll {
	overflow: auto;
}
.spacer {
	height: 30px;
}
.popup {
	&__panel {
		@include main-panel;
		display: flex;
	}
	&__left-panel {
		width: 400px;
		display: inline-block;
	}
	&__left-panel-search {
		width: 300px;
		margin-right: 5px;
	}
	&__rule-item {
		padding: 10px;
		border: 1px solid #eee;
		cursor: pointer;
	}
	&__rule-item-title {
		font-weight: 800;
		display: block;
		padding-bottom: 10px;
	}
	&__right-panel {
		border: 1px solid #eee;
		margin-left: 5px;
	}
	&__rules-disabled {
		opacity: 0.5;
	}
	&__button {
		font-size: 10px;
		padding: 5px;
	}
}
</style>
<template lang="pug">
div
	.classes(v-if="['class.management', 'teams'].includes(this.$route.name)")
		app-header
			.classes__header(slot="header")
				h1 {{ featureLabel }}s
				.classes__header__options
					el-button(@click="refetchClasses") Refetch and reset
					el-button(@click="dialogFormVisible=true") Configure target rules
					el-button(@click="generateClassroomsFromClasses") Create {{ featureLabel }}s from unmatched classes
					el-button(type="primary", :disabled="!savingEnabled", @click="saveMatches", :loading="savingMatches") {{ savingMatches ? 'Saving...' : 'Save' }}
		.classes__container
			.classes__panel
				.classes__grouping
					.clearfix.classes__toolbar
						span {{ featureLabel }} grouping and creation
						.right
							el-input.classes__search-input(placeholder="Type to search", size="small", v-model="TPClassSearchKey")
					loading(v-if="TPClassesLoading || savingMatches")
					template(v-else)
						empty(
							v-if="!thirdPartyClasses.length && !TPClassesLoading",
							:message="'No classrooms found.'"
						)
						.classes__draggable-panel(v-if="visibleClasses.length", ref="tpanel")
							provider-class-container.classes__card(
								v-for="(visibleClass, index) in visibleClasses"
								:key="visibleClass.id", 
								:providerClass="visibleClass", 
								:misClasses="classes", 
								@remove-match="removeClassroom",
								@update-name="updateName",
								:matchesInput="matchesInput")
						el-button(type="primary").classes__load-more-btn(@click="loadMore" :disabled="allLoaded") Load More
						.classes__footer-menu
							el-row
								el-col(:span="12")
									span Drag MIS classes to add or remove them from {{ featureLabel }}
								el-col(:span="12")
									el-row
										el-col(:span="12")
											el-switch(v-model="includeArchivedClasses")
											span.classes__switch-label Show archived classrooms
										el-col(:span="12")
											el-button.right(style="margin-top:-10px;", @click="addNewClassroom") Add {{ featureLabel }}
				.classes__mis-classes
					.clearfix.classes__toolbar
						span MIS Classes
						.right
							el-input.classes__search-input(placeholder="Type to search", size="small", v-model="MISClassSearchKey") 
					loading(v-if="$apollo.loading && !this.classes")
					template(v-else)
						empty(
							v-if="!classes",
							:message="'No MIS classes found.'"
						)
						.classes__draggable-panel.classes__pad-top15
							draggable
								mis-class-container.classes__card(
									v-if="classes && classes.length" v-for="(misClass, index) in filteredMISClasses" 
									:key="misClass.id + misClass.type", 
									:id="misClass.id", 
									:misClass="misClass", 
									:misClasses="classes",
									@create-class="createClass", 
									draggable, 
									@dragstart.native="drag",
									:persistedMatches="persistedMatches")
		logs-dialog(:isDialogVisible="logsDialogVisible", :workLength="matchesInput.length", :uuid="uuid", @close-logs-dialog="closeLogsDialog")
		<el-dialog title="Configure target rules" :visible.sync="dialogFormVisible" width="70%">
			el-form(style="margin-top:50px;")
				el-container
					el-aside.popup__left-panel(width="400px")
						div
							el-form-item
								el-input.popup__left-panel-search(v-model="targetSearchKey", width="20", placeholder="Type to search")
								el-button(@click="addNewTargetRule") Add
						.popup_rules-container.scroll(style="max-height: 500px;")
							loading(v-if="targetRulesLoading")
							template(v-else)
								.popup__rule-item(v-for="item in filteredTargetRules" :key="item.id", @click="showTargetRuleDetails(item)")
									el-row(v-if="item.is_enabled === true")
										el-col(:span="21")
											span.popup__rule-item-title {{ item.name }}
											//- span.popup__rule-item-description {{ item.description }}
										el-col(:span="3")
											el-button(v-if="!item.isSpeacialRule", type="danger" icon="el-icon-circle-close", size="mini", @click="removeTargetRule(item.id)")
									el-row(v-else)
										el-col.popup__rules-disabled(:span="21")
											span.popup__rule-item-title {{ item.name }}
											//- span.popup__rule-item-description {{ item.description }}
										el-col(:span="3")
											el-button(v-if="!item.isSpeacialRule", type="danger", icon="el-icon-circle-close", size="mini", @click="removeTargetRule(item.id)")
					el-container
						el-main.popup__right-panel
							el-row
								el-col(:span="7") Rule
								el-col(:span="17")
									el-input(v-model="form.name" :disabled="form.isSpeacialRule")
									el-checkbox(v-model="form.is_enabled") Enable rule
							.spacer
							el-row
								el-col.popup__rule-item-title MIS classes
							el-row
								el-col(:span="7") Find classes which match
								el-col(:span="17")
									el-input(v-model="form.target_class" :disabled="form.isSpeacialRule")
									small Regular expression patterns are allowed
							.spacer
							el-row
								el-col.popup__rule-item-title Target {{ featureLabel }}
							el-row
								el-col(:span="7") Assign to {{ featureLabel }} with name
								el-col(:span="17")
									custom-field-format(
										v-model="form.target_classroom",
										fieldLabel="",
										:fieldNames="fieldNames.class",
										:value="form.target_classroom",
										:persistedFormat="form.target_classroom"
                                )
							.spacer
							el-row
								el-col(:span="7") Don't use {{ featureLabel }} older than
								el-col(:span="17")
									el-input(style="width:50px;", v-model="form.isSpeacialRule ? 11 : form.max_classroom_age") 
									| &nbsp;months
							.spacer
							el-row
								el-col.popup__rule-item-title Preview
								el-button(@click="recalculate" :disabled="form.isSpeacialRule") Recalculate
							.scroll(style="max-height: 500px")
								loading(v-if="curthirdPartyClassesRuleFilteredLoading")
								template(v-else)
									empty(
										v-if="!curthirdPartyClassesRuleFiltered.length",
										:message="'No target rules found.'"
									)
									.classes__draggable-panel(v-if="curthirdPartyClassesRuleFiltered.length", ref="tpanel")
										provider-class-container.classes__card(
											v-for="(cls, index) in curthirdPartyClassesRuleFiltered" 
											:key="cls.id", 
											:providerClass="cls", 
											:misClasses="classes", 
											@remove-match="removeClassroom",
											@update-name="updateName",
											:readOnly="true")
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="saveTargetRule" :disabled="savingTargetRule" :loading="savingTargetRule">{{ savingTargetRule ? "Saving" : "Save" }}</el-button>
			</span>
		</el-dialog>
	<router-view></router-view>

</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import ProviderClassContainer from "./classes/Container.vue"
import MisClassContainer from './classes/MISClassContainer.vue';
import Draggable from 'vuedraggable'
import CustomFieldFormat from "../includes/CustomFieldFormat.vue"
import Fuse from "fuse.js";
import { v1 as uuidv1 } from 'uuid';
import Bugsnag from "@bugsnag/js";
import LogsDialog from "./classes/LogsDialog.vue";

export default {
	data() {
		return {
			thirdPartyClasses: [],
			refetchingTPClasses: false,
			refetchingMISClasses: false,
			includeArchivedClasses: false,
			classesPerPage: 54,
			currentPage: 0,
			allLoaded: false,
			dialogFormVisible: false,
			fieldNames: {
                class: {
                    "school-name": {
                        label: "School name",
                        value: "school_name"
                    },
                    "class-name": {
                        label: "Class name",
                        value: "class_name"
                    },
                    "class-description": {
                        label: "Class description",
                        value: "class_description"
                    },
                    "academic-year": {
                        label: "Academic year",
                        value: "academic_year"
                    },
                    "class-subject-name": {
                        label: "Subject name",
                        value: "class_subject_name"
                    },
                },
			},
			form: {
				target_classroom: "",
			},
			targetSearchKey: "",
			targetRules: [],
			currentTargetRuleId: null,
			savingTargetRule: false,
			matchedClassroomsFromRule: [],
			TPClassSearchKey: "",
			MISClassSearchKey: "",
			newClassrooms: [],
			ThirdPartyClass: {
				id: null,
				name: "",
				courseState: "NEW",
				ownerId: "",
				misClasses: [],
				members: [],
			},
			persistedMatches: [],
			savingMatches: false,
			curthirdPartyClassesRuleFiltered: [],
			curthirdPartyClassesRuleFilteredLoading: false,
			hasCreatedClassesFromUnmatched: false,
			logsDialogVisible: false,
			uuid: "",
			classes: [],
			targetRulesLoading: false,
		};
	},
	components: {
		ProviderClassContainer,
		Draggable,
		CustomFieldFormat,
		MisClassContainer,
		LogsDialog
	},
	computed: {
		featureLabel() {
			return ({
				"gapps": "Classroom",
				"msft": "Team"
			})[this.providerCode];
		},
		TPClassesLoading() {
			if(this.refetchingTPClasses) return true;
			return _.isEmpty(this.thirdPartyClasses);
		},
		filteredTargetRules() {
			return _.filter(this.targetRules, (rule) => {
				return rule.name.toLowerCase().includes(this.targetSearchKey) || rule.name.toLowerCase().includes(this.targetSearchKey)
			})
		},
		visibleClasses() {
			const options = {
				keys: ["name"],
				shouldSort: true,
			};
			const fuse = new Fuse(this.thirdPartyClasses, options);
			const start = this.currentPage * this.classesPerPage;
			const end = start + this.classesPerPage;
			let visibleClasses = _.isEmpty(this.TPClassSearchKey) ? this.thirdPartyClasses.slice(0, end) : fuse.search(this.TPClassSearchKey).slice(0, end);

			visibleClasses = _.filter(visibleClasses, (cls) => {
				return !_.isEmpty(cls.id);
			})

			return _.concat(visibleClasses, this.newClassrooms);
		},
		filteredMISClasses() {
			const options = {
				keys: ["name"],
				shouldSort: true,
			};
			const fuse = new Fuse(this.classes, options);

			if (this.MISClassSearchKey.trim().toLowerCase() === "none") {
				const unmatchedMISClassesIds = _.map(this.unmatchedMISClasses, (ucls) => ucls.id);
				
				return _.filter(this.classes, (cls) => {
					return unmatchedMISClassesIds.includes(cls.id);
				})
			}

			return _.isEmpty(this.MISClassSearchKey) ? (this.classes ? this.classes : []): fuse.search(this.MISClassSearchKey);
		},
		matchesInput() {
			let input = [];
			const changes = _(this.thirdPartyClasses)
				.differenceWith(this.persistedMatches, _.isEqual)
				.map((cls) => {
					const persistedMatch = _.find(this.persistedMatches, { id: cls.id });
					const misClasses = _.isEmpty(persistedMatch) ? [] : _(persistedMatch.misClasses)
						.differenceWith(cls.misClasses, _.isEqual)
						.value();
				
					if (!_.isEmpty(cls.misClasses)) {
						cls.misClasses.forEach((classId) => {
							const misClass = _.find(this.classes, { id: classId });
							if (cls.courseState === "ARCHIVE" && _.find(input, { courseState: "ARCHIVE", providerId: cls.id })) return null;
							
							if (!_.isEmpty(misClass) && persistedMatch && !persistedMatch.misClasses.includes(misClass.id)) {
								input.push({
									wondeId: this.sanitizeId(classId),
									wondeIdType: misClass.type,
									providerId: cls.id,
									name: cls.name,
									courseState: cls.courseState,
									displayName: cls.displayName,
								});
							}
						})
					} else {
						input.push({
							wondeId: null,
							wondeIdType: null,
							providerId: cls.id,
							name: cls.name,
							courseState: cls.courseState,
							displayName: cls.displayName,
						});
					}

					misClasses.forEach((classId) => {
						const misClass = _.find(this.classes, { id: classId });

						if (!_.isEmpty(misClass)) {
							input.push({
								wondeId: this.sanitizeId(classId),
								wondeIdType: misClass.type,
								providerId: cls.id,
								name: cls.name,
								courseState: "REMOVE",
							});
						}
					});
					
					return cls;
				})
				.value();
			
			const additions = _.map(this.newClassrooms, (cls) => {
				if (_.isEmpty(cls.misClasses)) {
					input.push({
						wondeId: null,
						wondeIdType: null,
						providerId: cls.id,
						name: cls.name,
						courseState: "NEW",
					});
				} else {
					if (cls.misClasses.length == 1) {
						const misClass = _.find(this.classes, { id: _.first(cls.misClasses) });
						input.push({
							wondeId: this.sanitizeId(misClass.id),
							wondeIdType: misClass.type,
							providerId: cls.id,
							name: cls.name,
							courseState: "NEW",
							displayName: cls.displayName,
						});
					} else {
						input.push({
							wondeId: null,
							wondeIdType: null,
							providerId: cls.id,
							name: cls.name,
							courseState: "NEW",
							displayName: cls.displayName,
							misClasses: _(this.classes)
								.filter((misClass) => cls.misClasses.includes(misClass.id))
								.map((misClass) => {
									return {
										id: misClass.id,
										type: misClass.type
									}
								})
								.value()
						});
					}
				}
			})
		
			return input;
		},
		savingEnabled() {
			if (!_.isEmpty(this.newClassrooms)) return true;
			if (_.isEmpty(this.thirdPartyClasses) || _.isEmpty(this.persistedMatches)) return false;

			return !_.isEqual(
				_.sortBy(this.thirdPartyClasses, Object.keys(this.thirdPartyClasses[0])),
				_.sortBy(this.persistedMatches, Object.keys(this.persistedMatches[0]))
			);
		},
		unmatchedMISClasses() {
			const matchedMISClasses = _(this.thirdPartyClasses)
				.map((cls) => cls.misClasses)
				.flatten()
				.uniq()
				.value();
			
			return _.filter(this.classes, (cls) => {
				return !matchedMISClasses.includes(cls.id);
			})
		},
	},
	methods: {
		addNewClassroom(cls = null) {
			this.newClassrooms.push({
				...this.ThirdPartyClass,
				name: cls.name ? cls.name : `New ${this.featureLabel}`,
				misClasses: cls.misClasses ? cls.misClasses :  [],
				id: uuidv1(),
			});
		},
		lazyLoadClasses() {
			if (this.visibleClasses.length - this.newClassrooms.length >= this.thirdPartyClasses.length) {
				this.allLoaded = true;
			} else {
				this.currentPage += 1;
			}
		},
		loadMore() {
			this.lazyLoadClasses();
			this.$refs.tpanel.scrollTop = this.$refs.tpanel.scrollHeight;
		},
		addNewTargetRule() {
			this.targetRules.push({
				name: "New target rule",
				description: "New description",
				id: `new-${ uuidv1() }`,
				is_enabled: true,
			})
		},
		async removeTargetRule(id) {
			this.$confirm(
				`Are you sure you want to remove this target rule?`,
				"Warning",
				{
					confirmButtonText: "OK",
					cancelButtonText: "Cancel",
					type: "warning"
				}
			).then(async () => {
				if (!id.toString().includes('new')) {
					try {
						await this.$apollo.mutate({
							mutation: gql`
								mutation ClassRuleMutation($input: ClassRuleInput!) {
									ClassRuleMutation(input: $input)
								}
							`,
							variables: {
								input: {
									action: "remove",
									id
								}
							}
						});
						this.targetRules = _.filter(this.targetRules, (rule) => {
							return rule.id != id;
						});
						this.$message.success("Target rule saved successfully");
						this.savingTargetRule = false;
					} catch (error) {
						Bugsnag.notify(JSON.stringify(error, null, 2));
						this.$message.error("Failed to remove target rule");
						this.savingTargetRule = false;
					}
				} else {
					this.targetRules = _.filter(this.targetRules, (rule) => {
						return rule.id != id;
					});
				}
				this.resetTargetRuleForm();
			});
		},
		showTargetRuleDetails(rule) {
			rule.is_enabled = rule.is_enabled == 1;
			this.form = rule;
			this.currentTargetRuleId = rule.id;
			this.recalculate();
		},
		resetTargetRuleForm() {
			this.form.is_enabled = false;
			this.form.name = "";
			this.form.target_classroom = "";
			this.form.target_class = "";
			this.form.max_classroom_age = "";
		},
		async saveTargetRule() {
			this.savingTargetRule = true;
			if (!this.currentTargetRuleId) {
				this.savingTargetRule = false;
				return;
			}

			const input = _.cloneDeep(this.form);
			delete input.__typename;
			input.action = input.id.includes("new") ? "create" : "update";
			input.max_classroom_age = parseInt(input.max_classroom_age)

			try {
				await this.$apollo.mutate({
					mutation: gql`
						mutation ClassRuleMutation($input: ClassRuleInput!) {
							ClassRuleMutation(input: $input)
						}
					`,
					variables: {
						input
					}
				});
				this.$message.success("Target rule saved successfully");
				this.savingTargetRule = false;
				this.$apollo.queries.targetRules.refetch();
			} catch (error) {
				console.log(error)
				Bugsnag.notify(JSON.stringify(error, null, 2));
				this.$message.error("Failed to save target rule");
				this.savingTargetRule = false;
			}
		},
		async recalculate() {
			this.curthirdPartyClassesRuleFiltered = [];
			this.curthirdPartyClassesRuleFilteredLoading = true;
			const data = await this.$apollo.query({
				query: gql`
					query ThirdPartyClasses($rule: ClassRuleInput!) {
						ThirdPartyClasses(rule: $rule) {
							id
							name
							courseState
							ownerId
							emailAddress
							misClasses
							members {
								id
								name
								emailAddress
							}
							createTime
						}
					}
				`,
				variables: {
					rule: {
						target_class: this.form.target_class,
						target_classroom: this.form.target_classroom,
						max_classroom_age: parseInt(this.form.max_classroom_age),
						action: "list-filtered"
					}
				},
				fetchPolicy: "network-only",
			});
			this.curthirdPartyClassesRuleFiltered = data.data.ThirdPartyClasses;
			this.curthirdPartyClassesRuleFilteredLoading = false;
		},
		drag(ev) {
			ev.dataTransfer.setData("draggedClassId", ev.target.id);
		},
		removeClassroom(providerClassId) {
			this.thirdPartyClasses = _.map(this.thirdPartyClasses, (cls) => {
				if (cls.id === providerClassId) {
					const persistedMatch = _.find(this.persistedMatches, { id: providerClassId });
					cls.courseState = cls.courseState === "ARCHIVE" ? persistedMatch.courseState || "ACTIVE" : "ARCHIVE";
				}
				
				return cls;
			});

			this.newClassrooms = _.filter(this.newClassrooms, (cls) => cls.id !== providerClassId);
		},
		updateName(classId, className) {
			this.thirdPartyClasses = _.map(this.thirdPartyClasses, (cls) => {
				if (cls.id === classId) {
					cls.name = className;
					cls.displayName = className;

					console.log(cls)
				}

				return cls;
			});

			this.newClassrooms = _.map(this.newClassrooms, (cls) => {
				if (cls.id === classId) {
					cls.name = className;
					cls.displayName = className;

					console.log(className)
				}

				return cls;
			});
		},
		async saveMatches() {
			this.logsDialogVisible = false;
			this.logsDialogVisible = true;
			this.uuid = "";

			try {
				const {
					data: { ManageClasses: uuid },
				} = await this.$apollo.mutate({
					mutation: gql`
						mutation ManageClasses($input: [MatchClassInput!]!) {
							ManageClasses(input: $input)
						}
					`,
					variables: {
						input: this.matchesInput
					}
				});

				this.uuid = uuid;
			} catch (error) {
				console.log(error)
				Bugsnag.notify(JSON.stringify(error, null, 2));
				this.$message.error("Failed to save matches");
			}
		},
		async clearClassesCache(item = "classes") {
			try {
				await this.$apollo.mutate({
					mutation: gql`
						mutation CacheClear($item: CacheTypeEnum!){
							CacheClear(item: $item)
						}`,
						variables: {
							item
						}
				});
			} catch (e) {
				console.log(e)
				Bugsnag.notify(JSON.stringify(e, null, 2));
				this.$message.error("Failed to re-fetch classes");
			}
		},
		async refetchClasses() {
			this.hasCreatedClassesFromUnmatched = false;
			this.newClassrooms = [];
			this.thirdPartyClasses = [];
			this.refetchingTPClasses = true;
			this.persistedMatches = [];
			await this.clearClassesCache();
			await this.$apollo.queries.classes.refetch();
			await this.$apollo.queries.thirdPartyClasses.refetch();
			this.savingMatches = false;
		},
		generateClassroomsFromClasses() {
			for (let cls of this.unmatchedMISClasses) {
				this.addNewClassroom({
					...cls,
					name: "Default",
					misClasses: [`${cls.id}`]
				});
			}

			this.hasCreatedClassesFromUnmatched = true;
		},
		sanitizeId (id) {
			return id.split("-")[0];
		},
		async closeLogsDialog() {
			this.logsDialogVisible = false;
			this.uuid = null;
			await this.refetchClasses();
		},
		createClass(id) {
			const cls = _.find(this.classes, { id });

			this.addNewClassroom({
				...cls,
				name: "Default",
				misClasses: [`${cls.id}`]
			});
		}
	},
	 watch: {
		unmatchedMISClasses(newVal, oldVal) {
			if(newVal && this.classes.length && this.thirdPartyClasses.length && !this.hasCreatedClassesFromUnmatched) {
				// this.generateClassroomsFromClasses();
				// this.hasCreatedClassesFromUnmatched = true;
			}
		},
	},
	apollo: {
		// SP Provider Data
		thirdPartyClasses: {
			query: gql`
				query ThirdPartyClasses($includeArchived: Boolean!, $rule: ClassRuleInput!) {
					ThirdPartyClasses(includeArchived: $includeArchived, rule: $rule) {
						id
						name
						courseState
						ownerId
						emailAddress
						misClasses
						members {
							id
							name
							emailAddress
						}
					}
				}
			`,
			variables() {
				return {
					includeArchived: this.includeArchivedClasses,
					rule: {
						action: "list"
					}
				}
			},
			pollInterval: 5000,
			fetchPolicy: "no-cache",
			update(r) {
				if (r.ThirdPartyClasses && r.ThirdPartyClasses.length > 0) {
					this.refetchingTPClasses = false;
				}

				r.ThirdPartyClasses.sort((a, b) => {
					return a.name.localeCompare(b.name);
				});

				return r.ThirdPartyClasses;
			},
			error(e) {
				this.$message({
					type: "error",
					message: `Something went wrong. Please refresh the page.`,
					duration: 0,
					showClose: true
				});
			},
			skip() {
				return !this.TPClassesLoading;
			},
		},

		persistedMatches: {
			query: gql`
				query ThirdPartyClasses($includeArchived: Boolean!) {
					ThirdPartyClasses(includeArchived: $includeArchived) {
						id
						name
						courseState
						ownerId
						emailAddress
						misClasses
						members {
							id
							name
							emailAddress
						}
					}
				}
			`,
			variables() {
				return {
					includeArchived: this.includeArchivedClasses
				}
			},
			pollInterval: 5000,
			fetchPolicy: "no-cache",
			update(r) {
				return r.ThirdPartyClasses;
			},
			error(e) {
				this.$message({
					type: "error",
					message: `Something went wrong. Please refresh the page.`,
					duration: 0,
					showClose: true
				});
			},
			skip() {
				return !this.TPClassesLoading && this.persistedMatches.length;
			},
		},
	
		targetRules: {
			query: gql`
				{
					ClassRules {
						id
						name
						is_enabled
						target_class
						target_classroom
						max_classroom_age
						order
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			update (r) {
				this.targetRulesLoading = false;
				return r.ClassRules;
			}
				
		},

		classes: {
			query: gql`
				{
					Classes {
						id
						name
						type
						code
					}
				}
			`,
			fetchPolicy: "no-cache",
			update: r => {
				return _(r.Classes)
					.map(cls => ({
						...cls,
						id: `${cls.id}-${cls.type}`,
						assigned: null
					}))
					.sortBy("name")
					.value();
			}
				
		},

		classSettings: {
			query: gql`
				{
					Settings {
						id
						include_class_code
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			update: r => {
				return r.Settings;
			}
		}
	}
};
</script>
